import { styled } from '@linaria/react'
import { COLOR, FIXED_INDENTS, MEDIA } from 'vars/index'
import { MultiColumns } from '../../MultiColumns'
import { MCItemDirectorsStarsSC } from '../MultiColumnsItem/MCItemDirectorsStars.styled'

export const MCDescriptionWithMoreTemplate = styled(MultiColumns)`
  ${MCItemDirectorsStarsSC} {
    ${MEDIA.MAX_1239} {
      display: none;
    }
  }
`

/**
 * `banner-description` from the content details concept, the block that follows
 * the banner and carries the description, directors and stars of the title.
 */
export const DetailsAreaSC = styled.div`
  --detailsAreaPaddingVertical: var(${FIXED_INDENTS.INDENT_80});
  --detailsAreaPaddingHorizontal: var(${FIXED_INDENTS.INDENT_200});

  box-sizing: border-box;
  display: flex;
  width: 100%;
  background: var(${COLOR.SURFACE_DARK});
  padding: var(--detailsAreaPaddingVertical) var(--detailsAreaPaddingHorizontal);

  ${MEDIA.MAX_1639} {
    --detailsAreaPaddingHorizontal: var(${FIXED_INDENTS.INDENT_160});
  }

  ${MEDIA.MAX_1239} {
    --detailsAreaPaddingVertical: var(${FIXED_INDENTS.INDENT_60});
    --detailsAreaPaddingHorizontal: var(${FIXED_INDENTS.INDENT_80});
  }

  ${MEDIA.MAX_599} {
    --detailsAreaPaddingVertical: var(${FIXED_INDENTS.INDENT_50});
    --detailsAreaPaddingHorizontal: var(${FIXED_INDENTS.INDENT_40});
  }
`
